import { Injectable, OnDestroy } from '@angular/core';
import { RepoAuthService } from '../../data/repositories/repo-auth.service';
import { DialogService } from './dialog.service';

@Injectable({ providedIn: 'root' })
export class AuthTokenService implements OnDestroy {
    private interval?: number;
    everyMin = 1000 * 60;

    constructor(
        private repoAuth: RepoAuthService,
        private dialogService: DialogService
    ) {}

    start() {
        this.interval = window.setInterval(() => this.checkToken(), this.everyMin);
        this.repoAuth.checkDisablingMfaFlag();
    }

    ngOnDestroy() {
        if (this.interval) window.clearInterval(this.interval);
    }

    checkToken() {
        // this should only be called once we are logged in.
        // above validates that we have logged in regardless of current authentication status
        this.repoAuth.checkAuth0Session(true).then((sessionIsOK) => {
            if (!sessionIsOK && !this.repoAuth.currentUrlIsAPublicRoute()) {
                // prevent further checking of token
                window.clearInterval(this.interval);

                this.dialogService
                    .show({
                        type: 'warning',
                        title: 'Login Required',
                        text: 'To continue using Buildxact, please re-enter your password after clicking OK.',
                        showCancel: false,
                        okText: 'OK',
                    })
                    .then((result) => {
                        return this.repoAuth.auth0LoginWithPopup();
                    })
                    .then(() => {
                        //the external popup has completed, renable checking.
                        //note, this will not fire if they just close the popup dialog.
                        this.interval = window.setInterval(() => this.checkToken(), this.everyMin);
                    })
                    .catch((loginError) => {
                        //the account is either blocked, the password was wrong or there was a network error
                        //just let the user know and let them go around the cycle again.
                        this.dialogService
                            .show({
                                type: 'error',
                                title: 'Login Failed',
                                text: 'Sorry, it looks like your login attempt failed.  Please contact support for assistance.',
                                okText: 'OK',
                                showCancel: false,
                            })
                            .then((result) => {
                                this.interval = window.setInterval(() => this.checkToken(), this.everyMin);
                            });
                    });
            }
        });
    }
}
